module.exports = __webpack_public_path__ + "media/images/method-phone_transfer-c3b3312a38249345c118d8e571c3a90f.png";